import React from 'react';

const CHUNK_ERROR_PATTERN = /chunkloaderror|loading chunk|failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module/i;

const isChunkError = (error) => CHUNK_ERROR_PATTERN.test(
    `${error?.name || ''} ${error?.message || error || ''}`
);

/**
 * Retry a failed dynamic import once. Transient CDN timeouts and a stale
 * deployment manifest are common in production; retrying before showing the
 * route error screen prevents a single failed chunk request from trapping the
 * user on a blank page.
 */
export const lazyWithRetry = (importer, resolveModule = (module) => module) => (
    React.lazy(async () => {
        try {
            return resolveModule(await importer());
        } catch (firstError) {
            if (!isChunkError(firstError)) throw firstError;

            await new Promise((resolve) => setTimeout(resolve, 350));

            try {
                return resolveModule(await importer());
            } catch (secondError) {
                throw secondError || firstError;
            }
        }
    })
);

export default lazyWithRetry;
